'use es6';

import { List, Record } from 'immutable';
import { RequestStatus } from '../constants/base';
import Video from './Video';
const DEFAULTS = {
  data: List(),
  status: RequestStatus.UNINITIALIZED
};
export default class VideoMap extends Record(DEFAULTS) {
  static fromJS(data) {
    return new VideoMap({
      data: List(data).map(Video.fromJS),
      status: RequestStatus.SUCCEEDED
    });
  }
}